export default [
  {
    path: "homework-status",
    name: "settings-homework-status",
    redirect: { name: "homework-status-active" },
    component: () => import("@/views/settings/views/homework-status/HomeworkStatus.vue"),
    meta: {
      section: 3,
      breadcrumb: [
        {
          text: "homework status",
        },
      ],
      tabs: [
        {
          title: "active",
          name: "homework-status-active",
        },
        {
          title: "inactive",
          name: "homework-status-inactive",
        },
      ],
    },
    children: [
      {
        path: "Active",
        name: "homework-status-active",
        component: () =>
          import(
            /* webpackChunkName: "TareoStatusActive" */ "@/views/settings/views/homework-status/components/Grid.vue"
          ),
        meta: {
          section: 3,
          pageTitle: "homework status",
          breadcrumb: [
            {
              text: "active",
              active: true,
            },
          ],
          tab: 1,
        },
      },
      {
        path: "Inactive",
        name: "homework-status-inactive",
        component: () =>
          import(
            /* webpackChunkName: "TareoStatusInactive" */ "@/views/settings/views/homework-status/components/Grid.vue"
          ),
        meta: {
          section: 3,
          breadcrumb: [
            {
              text: "homework status",
            },
            {
              text: "inactive",
              active: true,
            },
          ],
          tab: 2,
        },
      },
    ],
  },
];
